import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import {
  SET_TOURNAMENT_LOGGED_RUN_LIST,
  SET_TOURNAMENT_LOGGED_RUN_PARAMETERS,
  SHOW_TOURNAMENT_LOGGED_RUN_LOADING_SPINNER,
  TOGGLE_OPEN_LOGGED_RUN
} from '../actions/keystoneLoggedRunTournamentActionCreator';

const roleSorts: any = {
  tank: 1,
  healer: 2,
  dps: 3
};

function ordinalForRole(role: string): number {
  if (!role) {
    return 999;
  }
  const roleCheck = role.toLowerCase();
  return roleSorts[roleCheck] || 999;
}

function sortRoster(a: any, b: any) {
  const aRoleOrder = ordinalForRole(a.role);
  const bRoleOrder = ordinalForRole(b.role);
  if (aRoleOrder === bRoleOrder) {
    if (b.character.name === a.character.name) {
      return 0;
    } else if (a.character.name < b.character.name) {
      return -1;
    } else {
      return 1;
    }
  } else {
    return aRoleOrder - bRoleOrder;
  }
}

const DEFAULT_STATE = {
  runs: [],
  isLoading: false,
  openLoggedRuns: {}
};

export default function keystoneLoggedRunTournament(
  state: Partial<any> = DEFAULT_STATE,
  action: TAction<any>
): Partial<any> {
  switch (action.type) {
    case SET_TOURNAMENT_LOGGED_RUN_LIST: {
      const runs = action.payload.runs || [];
      runs.forEach((group: any) => {
        group.roster.sort(sortRoster);
      });

      return {
        ...state,
        runs
      };
    }
    case SET_TOURNAMENT_LOGGED_RUN_PARAMETERS: {
      return {
        ...state,
        ui: action.payload.params
      };
    }
    case SHOW_TOURNAMENT_LOGGED_RUN_LOADING_SPINNER: {
      return {
        ...state,
        isLoading: action.payload.loading
      };
    }
    case TOGGLE_OPEN_LOGGED_RUN: {
      return {
        ...state,
        openLoggedRuns: {
          ...(state.openLoggedRuns || {}),
          [action.payload]: state.openLoggedRuns ? !state.openLoggedRuns[action.payload] : true
        }
      };
    }
    default: {
      return state;
    }
  }
}
